module.exports = __webpack_public_path__ + "img/tit-exam.b6280457.jpg";